module.exports = __webpack_public_path__ + "img/39_6.19863727.png";